import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import GiftBlueSvg from '../../assets/icons/gift_blue.svg';

class HLBEligibleBanner extends Component {
  static propTypes = {
    onJoinCampaign: PropTypes.func,
  }

  handleJoinCampaign = (e) => {
    e.preventDefault();
    if (this.props.onJoinCampaign) {
      this.props.onJoinCampaign();
    }
  }

  render() {
    return (
      <div className="hlb-eligible-banner">
        <img src={GiftBlueSvg} width={20} alt="gift" />
        <span>
          <strong>MHub Rewards: </strong>
          Hong Leong Bank selected. You are eligible for RM10 cash payout. To qualify, fill up your bank information,
          <Link onClick={this.handleJoinCampaign}> click here.</Link>
        </span>
      </div>
    );
  }
}

export default HLBEligibleBanner;



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBEligibleBanner.jsx